import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useQRCodeService = () => {
  const { language } = useLanguage();
  const t = messageTranslations[language]?.qr || messageTranslations["de"].qr;

  const createQRCode = async (formData) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/qrcode/create`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: formData,
        }
      );

      if (!response.ok) throw new Error(t.createError);

      const qrCodeData = await response.json();
      message.success(t.createSuccess);
      return qrCodeData.qrCode;
    } catch (error) {
      console.error("QR erstellen:", error.message);
      message.error(t.createError);
      return null;
    }
  };

  const getQRCodes = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/qrcode/getqrcodes`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) throw new Error(t.loadError);

      return await response.json();
    } catch (error) {
      console.error("QR laden:", error.message);
      message.error(t.loadError);
      return [];
    }
  };

  const editQRCode = async (id, updates) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/qrcode/edit/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify(updates),
        }
      );

      if (!response.ok) throw new Error(t.editError);

      const updated = await response.json();
      message.success(t.editSuccess);
      return updated.qrCode;
    } catch (error) {
      console.error("QR bearbeiten:", error.message);
      message.error(t.editError);
      return null;
    }
  };

  const deleteQRCode = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/qrcode/delete/${id._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) throw new Error(t.deleteError);

      message.success(t.deleteSuccess);
      return true;
    } catch (error) {
      console.error("QR löschen:", error.message);
      message.error(t.deleteError);
      return false;
    }
  };

  return {
    createQRCode,
    getQRCodes,
    editQRCode,
    deleteQRCode,
  };
};

export default useQRCodeService;
